// LIBRARIES
import styled from "styled-components";
import { Swiper } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

// MISC
import { COLORS, FONTS } from "constants/styleVariables";

export const EventsContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: 60px 80px 0 80px;
`;
export const Events = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 60px;
`;
export const Subtitle = styled.div`
  font-size: 20px;
  color: ${COLORS.secondaryBlack};
  font-weight: bold;
  font-family: ${FONTS.montserrat};
  margin-bottom: 20px;
`;
export const Link = styled.text`
  font-size: 18px;
  font-family: ${FONTS.newsharp};
  font-weight: bold;
  color: ${COLORS.cornflowerBlue};
  text-decoration: underline;
  text-decoration-color: ${COLORS.cornflowerBlue};
  cursor: pointer;
`;
export const SubtitlesContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const SwiperContainer = styled(Swiper)`
  display: flex;
  flex-direction: row;
  max-width: 1560px;
  padding-bottom: 20px;

  .swiper-pagination-clickable .swiper-pagination-bullet-active {
    background: ${COLORS.gradientBlueColors};
  }
`;

export const EventCards = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex-wrap: wrap;
`;
export const ButtonContainer = styled.div`
  max-width: 221px;
  margin-bottom: 60px;
`;

export const CardContainerr = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 200px;
  height: 190px;
  background: greenyellow;
`;
